import { StageDefinition } from './StageDefinition';

export const stage05: StageDefinition = {
    platforms: [
        [46.45161290322581, 0],
        [58.064516129032256, 0],
        [69.6774193548387, 0],
        [92.9032258064516, 0],
        [116.1290322580645, 0],
        [127.74193548387095, 0],
        [150.96774193548387, 0],
        [185.80645161290326, 0],
        [209.03225806451618, 0],
        [255.48387096774204, 0],
        [313.5483870967743, 0],
        [85.26315789473684, 1],
        [94.73684210526315, 1],
        [104.21052631578947, 1],
        [123.1578947368421, 1],
        [151.57894736842104, 1],
        [179.99999999999994, 1],
        [189.47368421052624, 1],
        [208.42105263157885, 1],
        [255.78947368421035, 1],
        [312.63157894736815, 1],
        [114.54545454545458, 2],
        [122.72727272727276, 2],
        [130.90909090909093, 2],
        [147.2727272727273, 2],
        [155.4545454545455, 2],
        [180.00000000000006, 2],
        [188.18181818181824, 2],
        [204.54545454545462, 2],
        [212.7272727272728, 2],
        [253.63636363636374, 2],
        [310.90909090909105, 2],
        [144, 3],
        [151.2, 3],
        [158.39999999999998, 3],
        [179.99999999999994, 3],
        [187.19999999999993, 3],
        [201.5999999999999, 3],
        [208.7999999999999, 3],
        [215.9999999999999, 3],
        [251.99999999999983, 3],
        [259.1999999999998, 3],
        [309.59999999999974, 3],
        [170.5263157894737, 4],
        [176.84210526315792, 4],
        [183.15789473684214, 4],
        [189.47368421052636, 4],
        [195.78947368421058, 4],
        [202.1052631578948, 4],
        [208.42105263157902, 4],
        [214.73684210526324, 4],
        [221.05263157894746, 4],
        [227.36842105263167, 4],
        [252.63157894736855, 4],
        [258.9473684210528, 4],
        [309.4736842105265, 4],
        [245.7142857142858, 5],
        [251.42857142857153, 5],
        [257.1428571428572, 5],
        [262.85714285714295, 5],
        [308.5714285714287, 5],
        [281.7391304347823, 6],
        [286.9565217391301, 6],
        [292.1739130434779, 6],
        [297.3913043478257, 6],
        [302.60869565217354, 6],
        [307.82608695652135, 6],
        [313.04347826086916, 6],
        [318.260869565217, 6],
        [323.4782608695648, 6],
        [328.6956521739126, 6],
        [333.9130434782604, 6],
    ],
    traps: [],
    stars: [
        [25, 1],
        [67, 2],
        [102, 3],
        [131, 4],
        [160, 5],
        [197, 6],
        [219, 6],
        [248, 7],
        [262, 7],
        [297, 8],
        [321, 8],
        [351, 8],
        [318, 8],
    ],
};
